__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/53e9789ffec2d3120109273bd3baacfffacb50f4/_next/";